var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("FormStream", {
                attrs: {
                  data: _vm.stream,
                  loading: _vm.isFormLoading,
                  disabled: _vm.isMutationLoading,
                  isNew: !_vm.id,
                  language: _vm.language,
                },
                on: {
                  submit: _vm.onFormSubmit,
                  cancel: function ($event) {
                    return _vm.$router.push({ name: "page-streams" })
                  },
                  "delete-stream": _vm.deleteDevice,
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmStreamRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }